module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ec42dec886c8f6f5ef02237e9d56d2a7.gif";